<template>
	<div class="prog_reg-header">
		<div class="container">
			<div class="row">
				<div class="col-md-6">
					<h2 class="title title-lg">
						Регистрация
					</h2>

					<div
						class="small"
					>
						{{ formData.subtitle }}
					</div>
					<b-progress v-if="getFilledStep(formData.id)" :max="countSteps" class="mb-2 mt-2" show-progress>
						<b-progress-bar :value="getFilledStep(formData.id)" :label="`${((getFilledStep(formData.id) / countSteps) * 100).toFixed(0)}%`" />
					</b-progress>
				</div>
				<div class="col-md-6 border-md-left">
					<div class="description mt-3 mt-md-2">
						<div v-if="projectType">
							{{ projectType }}
						</div>
						<div class="title">
							{{ formData.name }}
						</div>
					</div>
					<div
						v-if="getFilledStep(formData.id) !== 1"
						:class="[
							priceData.currency === 1 ? 'price' : '',
							priceData.currency === 2 ? 'usd-price' : '',
							priceData.currency === 3 ? 'eur-price' : '',
							priceData.currency === 4 ? 'cny-price' : '',
						]"
					>
						{{ priceString }}
					</div>

					<div v-if="getStep(formData.id) >= 2">
						<div v-if="product.vat ===1">
							Без НДС
						</div>
						<div v-else>
							Включая НДС
						</div>
					</div>
				</div>

				<div v-if="!formData.hide_promocode && (!getIsStudent(formData.id) || getStep(formData.id) === 1)" class="container mt-3">
					<div class="row">
						<div class="col-12 col-md-12 col-lg-12 mb-3">
							<div class="disclaimer alert theme-darkgray pl-0">
								<div class="row">
									<div class="col-12 col-md-12 col-lg-12">
										<b-form class="d-flex align-items-center justify-content-start" inline>
											<div class="mb-3 mb-sm-0 mr-sm-3 mr-lg-4">
												Введите промокод
											</div>
											<b-form-group id="example-input-group-1" class="d-inline-flex" :invalid-feedback="promocodeMessage" :state="promocodeMessage === ''">
												<b-form-input
													v-model="promocodeInput"
													:placeholder="'Промокод'"
													class="mb-3 mb-sm-0 mr-sm-3 mr-lg-4"
													name="promocode_input"
													aria-describedby="input-1-live-feedback"
												/>
												<button v-if="!priceData.promocode" class="btn btn-primary" @click.prevent="setPromocode(true)">
													Применить
												</button>
												<button v-if="priceData.promocode" class="btn btn-primary" @click.prevent="setPromocode(false)">
													Отменить
												</button>
											</b-form-group>
										</b-form>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import {
	CHECKOUT_STORE_NAMESPACE,
	ACTION_GET_PRICE_DATA,
} from '@/store/checkout';
import { mapGetters } from 'vuex';
import moment from '@/utils/moment';
import checkoutForm from '@/mixins/checkoutForm';

export default {
	name: 'CheckoutHeader',
	mixins: [checkoutForm],
	props: {
		formData: {
			type: Object,
			default: () => ({
				title: '',
				subtitle: '',
				right_column_text: '',
			}),
		},
		product: {
			type: Object,
			default: () => ({}),
		},
		countSteps: {
			type: Number,
			default: 6,
		},
		projectType: {
			type: String,
			default: null,
		},
	},
	data() {
		return {
			promocodeMessage: '',
			promocode: '',
		};
	},
	computed: {
		...mapGetters({
			getStep: 'checkout/getStep',
			getFilledStep: 'checkout/getFilledStep',
			getScenario: 'checkout/getScenario',
			getAdditionalPersonsCount: 'checkout/getAdditionalPersonsCount',
			getIsRegistrant: 'checkout/getIsRegistrant',
			getIsStudent: 'checkout/getIsStudent',
		}),
		promocodeInput: {
			set(value) {
				this.promocode = value;
			},
			get() {
				if (this.priceData.promocode) {
					return this.priceData.promocode.promocode;
				}
				return this.promocode;
			},
		},
		priceString() {
			let { basePrice } = this.priceData;
			let quantity = 1;
			let sum = 0;

			const dateNow = moment().endOf('day');
			if (moment(dateNow).isSameOrBefore(this.product.active_to, 'day') && moment(dateNow).isSameOrAfter(this.product.active_from, 'day')) {
				basePrice = this.priceData.individualPrice;
			}

			if (this.priceData.promocode) {
				if (this.priceData.individualPriceWithDiscount === this.priceData.individualPrice) {
					basePrice = this.priceData.price;
				} else {
					basePrice = this.priceData.individualPriceWithDiscount;
				}
			}

			if (this.getIsStudent(this.formData.id)) {
				basePrice = this.priceData.studentIndividualPriceWithDiscount || 0;
			}

			quantity = this.priceData.personCount;

			sum = basePrice * quantity;

			return `${basePrice} x ${quantity} = ${sum} ${this.priceData.currency_mark}`;
		},
	},
	methods: {
		async setPromocode(status) {
			const { uniqueId } = this.$store.state.uniqueId;
			if (!status) {
				await this.$api.removePromocode({
					formId: this.formData.id,
					uniqueId,
				});

				this.promocode = '';

				await this.$store.dispatch(`${CHECKOUT_STORE_NAMESPACE}/${ACTION_GET_PRICE_DATA}`, { formId: this.formData.id, uniqueId });

				return;
			}

			const response = await this.$api.applyPromocode({
				formId: this.formData.id,
				uniqueId,
				promocode: this.promocodeInput,
			});

			if (!response.status) {
				this.promocodeMessage = response.message;
				return;
			}

			this.promocodeMessage = '';

			await this.$store.dispatch(`${CHECKOUT_STORE_NAMESPACE}/${ACTION_GET_PRICE_DATA}`, { formId: this.formData.id, uniqueId });
		},
	},
};
</script>

<style lang="scss" scoped>
@import '~/assets/styles/sk_variables';
// For use bootstrap vars and mixins inside
@import "~/assets/styles/bootstrap/scss/functions";
@import "~/assets/styles/bootstrap/scss/variables";
@import "~/assets/styles/bootstrap/scss/mixins";
	.progress-bar {
		background-color: $primary;
	}
</style>
